import { ExportFileInfo } from './../../models/export-file-info';
import { ExcelExportService } from './../../services/excel-export-service.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AnalysisDrugList, AtpDrugList, CellLocatedSheet, CommonEntity, CustomerDrugCellLocationAtp, CustomerDrugInfo, DrugCellLog, DrugSystem, ListOfDrugLocationAtp, NotOralDrugList } from '../../models/customer-drug-info';
import { IMToolService } from '../../services/im-tool.service';
import { ImToolAtpService } from '../../services/im-tool-atp.service';
import { AlertWizardComponent } from '../alert-wizard/alert-wizard.component';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as constants from "src/app/config/app-constants";
import { ImportWizardCddbComponent } from '../import-wizard-cddb/import-wizard-cddb.component';
import { ImportWizardComponent } from '../import-wizard/import-wizard.component';
import { ImportWizardDrugMovingComponent } from '../import-wizard-drug-moving/import-wizard-drug-moving.component';
import { MoveDrug } from '../../models/move-drugs';
import { Observable, forkJoin } from 'rxjs';
import { Medication, MedicationXMLBrand, MedicationXml } from '../../models/medication-export';

@Component({
  selector: 'app-atp-caps-drug-list',
  templateUrl: './atp-caps-drug-list.component.html',
  styleUrls: ['./atp-caps-drug-list.component.scss'],
  standalone: false
})
export class AtpCapsDrugListComponent implements OnInit {
  fileInfo: ExportFileInfo;
  searchText: string = '';
  drugList: CustomerDrugInfo;
  drugSystemList: DrugSystem[] = [];
  celLogList: DrugCellLog[] = [];
  drugCellSize: CommonEntity[] = [];
  drugCellLocationUpdateList: ListOfDrugLocationAtp;
  drugCellLocationList: CustomerDrugCellLocationAtp[] = [];
  analysisDrugList: AnalysisDrugList[] = [];
  analysisDrugListCsv: AnalysisDrugList[] = [];
  notAvailableDrugList: AtpDrugList[] = [];
  excludedDrugList: AtpDrugList[] = [];
  notOralDrugList: NotOralDrugList[] = [];
  cellLocatorSheetList: CellLocatedSheet[] = [];
  //#region  Table datasourse
  dataSource = new MatTableDataSource<AtpDrugList>();
  dataSourceOral = new MatTableDataSource<AtpDrugList>();
  dataSourceExcluded = new MatTableDataSource<AtpDrugList>();
  dataSourceNotAbailable = new MatTableDataSource<AtpDrugList>();
  dataSourcecellLocatorSheet = new MatTableDataSource<CellLocatedSheet>();
  //#endregion
  @ViewChild(MatTable, { static: true }) drugTabletable: MatTable<any>;
  @ViewChild(CdkVirtualScrollViewport, { static: true })
  viewport: CdkVirtualScrollViewport;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("table", { read: MatSort, static: true }) sort: MatSort;
  @ViewChild("table1", { read: MatSort, static: true }) sort1: MatSort;
  @ViewChild("table2", { read: MatSort, static: true }) sort2: MatSort;
  @ViewChild("table3", { read: MatSort, static: true }) sort3: MatSort;
  @ViewChild("table4", { read: MatSort, static: true }) sort4: MatSort;
  @ViewChild("TABLE") table: ElementRef;
  @ViewChild("TABLE1") table1: ElementRef;
  @ViewChild("TABLE2") table2: ElementRef;
  @ViewChild("TABLE3") table3: ElementRef;
  @ViewChild("TABLE4") table4: ElementRef;
  @Output() sortChange: EventEmitter<MatSort> = new EventEmitter<MatSort>();

  selectedDrugSystem: number = 1;
  xmlAnalysisFormatData: MedicationXml = new MedicationXml();
  orderOrUsage: string = '# of Orders';
  phllDispLable: string = 'Pills Disp';
  analysisData: number;
  ndcOfMultippleLocation = new Array<string>();
  // Selected Row Color Change key
  selectedRow;

  isShowCellLocOnMouseHover: boolean = false;
  deviceId: number;
  customerName: string = "";
  targetInstallDate: string = "";
  subDeviceTypeName: string = "";
  locationAnalysis: string = "";
  primaryLabelName: string = "Primary Drug Name";
  secondaryLabelName: string = "Secondary Drug Name";
  deviceName: string = "";
  caseNumber: string = "";
  CustomerNumber: string = "";
  AssetNumber: string = "";
  ShippingCity: string = "";
  AccountNumber: string = "";
  ShippingStreet: string = "";
  ShippingState: string = "";
  ShippingPostalCode: string = "";
  caseId: string = "";
  caseLink: string = "";
  dessicant: string = "";

  dessicantsMapping: { [key: string]: string } = {
    "ATP(CAPS) - 64": "ACC-100 (Qty: 1)",
    "ATP(CAPS) - 128": "ACC-100 (Qty: 2)",
    "ATP(CAPS) - 192": "ACC-100 (Qty: 2)",
    "ATP(CAPS) - 256": "ACC-400 (Qty: 1)",
    "ATP(CAPS) - 320": "ACC-400 (Qty: 1)",
    "ATP(CAPS) - 400": "ACC-400 (Qty: 1)",
    "ATP(CAPS) - 480": "ACC-100 (Qty: 1); ACC-400 (Qty: 1)"
};



  //#region drawer count variables
  smartCount: number;
  regularCount: number;
  highCapCount: number;
  smartHighCapCount: number;
  noDrawerCount: number;
  remainingSmartCount: number;
  remainingHighCapCount: number;
  remainingSmartHighCapCount: number;
  remainingRegularCount: number;
  isMultipleCellLocation: boolean = false;
  smartCanisters: string = "";

  // DynamicColumn Show

  isApwColumnShow: boolean = false;
  isMarkingColumnShow: boolean = false;
  isQtyInCanisterShow: boolean = false;
  isPackQtyShow: boolean = false;
  isDiscriptionShow: boolean = false;
  isLotShow: boolean = false;
  isStrengthShow: boolean = false;
  isShapeShow: boolean = false;
  isColorShow: boolean = false;
  isBarCodeShow: boolean = false;
  isVolumeShow: boolean = false;
  isPillVolumeShow: boolean = false;
  isActiveShow: boolean = false;
  isUnRegulatedColumnShow: boolean = false;
  isHccShow:boolean = false;
  isSccShow:boolean = false;
  // Hide column

  isHideMfgExpiration: boolean = true;
  isHideCostPerPill: boolean = true;
  isHidecontrolSched: boolean = true;
  isHideComment: boolean = true;
  isHideDontMix: boolean = true;
  isHideMin: boolean = true;
  isHideMax: boolean = true;
  isHideInvoice: boolean = true;
  isHideSmartId: boolean = true;
  isHideAssignedLot: boolean = true;
  isHideAssignedExp: boolean = true;
  isHideDistributor: boolean = true;

  //#endregion

  //#region Table colums Array
  displayedColumns: string[] = [
    "checkbox",
    "topOrder",
    "ndc",
    "customerDrugNdc",
    "barcode",
    "primaryDrugName",
    "secondaryDrugName",
    "mfgExpiration",
    "strength",
    "location",
    "pillForm",
    "volume",
    "lot",
    "qtyInCanister",
    "atpCanisterNumber",
    "color",
    "shape",
    "marking",
    "description",
    "packQuantity",
    "costPerPill",
    "apw",
    "controlSched",
    "comment",
    "doNotMix",
    "active",
    "min",
    "max",
    "invoiceNumber",
    "smartId",
    "genericSequenceNumber",
    "assignedLot",
    "assignedExpiration",
    "distributor",
    "unitUsage",
    "drawer",
    "drawerType",
    "thirtyDramCapacity",
    "pillVolume",
    // "drugStatus",
    "isUnRegulated",
    "highCapCanister",
    "smartCapCanister",
    "action"
  ];

  displayedColumnsNotOral: string[] = [
    "checkbox",
    "topOrder",
    "ndc",
    "customerDrugNdc",
    "barcode",
    "primaryDrugName",
    "secondaryDrugName",
    "mfgExpiration",
    "dosageForm",
    "strength",
    "location",
    "pillForm",
    "volume",
    "lot",
    "qtyInCanister",
    "atpCanisterNumber",
    "color",
    "shape",
    "marking",
    "description",
    "packQuantity",
    "costPerPill",
    "apw",
    "controlSched",
    "comment",
    "doNotMix",
    "active",
    "min",
    "max",
    "invoiceNumber",
    "smartId",
    "genericSequenceNumber",
    "assignedLot",
    "assignedExpiration",
    "distributor",
    "unitUsage",
    "drawer",
    "drawerType",
    "thirtyDramCapacity",
    "pillVolume",
    // "drugStatus",
    "isUnRegulated",
    "action"
  ];
  displayedColumnsExcluded: string[] = [
    "checkbox",
    "topOrder",
    "excludedReason",
    "ndc",
    "customerDrugNdc",
    "barcode",
    "primaryDrugName",
    "secondaryDrugName",
    "mfgExpiration",
    "strength",
    "location",
    "pillForm",
    "volume",
    "lot",
    "qtyInCanister",
    "atpCanisterNumber",
    "color",
    "shape",
    "marking",
    "description",
    "packQuantity",
    "costPerPill",
    "apw",
    "controlSched",
    "comment",
    "doNotMix",
    "active",
    "min",
    "max",
    "invoiceNumber",
    "smartId",
    "genericSequenceNumber",
    "assignedLot",
    "assignedExpiration",
    "distributor",
    "unitUsage",
    "drawer",
    "drawerType",
    "thirtyDramCapacity",
    "pillVolume",
    // "drugStatus",
    "action"
  ];

  //#endregion

  customerId: string;

  // current which tab selected
  tabSelected: number = 0;
  currentFilterSize: number = 0;


  // All selected checkbox propertities
  isAnyDrugSelected: boolean = false;

  //isScrollButtonShow:boolean=false;

  moveDrug: MoveDrug = {} as MoveDrug;


  @HostListener("window:resize")
  onResize() {
    if (window.innerWidth > 900) {
    }
  }
  constructor(
    private dialog: MatDialog,
    private imtoolService: IMToolService,
    private imtoolAtpService: ImToolAtpService,
    private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private activateRoute: ActivatedRoute,
    private toastService: ToastService,
    private exportService: ExcelExportService
  ) {

  }

  ngOnInit(): void {

    this.drugSystemList.push(
      {
        id: 1,
        value: 2,
      },
      {
        id: 2,
        value: 5,
      }
    );



    this.activateRoute.paramMap.subscribe((params) => {
      this.customerId = params.get("customerid");
    });

    this.getRecommendedDrugData(this.customerId, 0);
    this.analysisData = this.dataSource.data.length;
    this.getAvailableCellLocation(this.customerId);


  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSourceNotAbailable.sort = this.sort1;
    this.dataSourceExcluded.sort = this.sort2;
    this.dataSourceOral.sort = this.sort3;
  }


  exportTheCanisterOrderFile() {

    let tableRow = 27;
    let tableData = this.analysisDrugList.map(x=>
      {
        let styleID = "S23";

      return `<Row ss:Index="${tableRow++}">
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.ndc ==null?'':x.ndc.substring(0, 9)}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${this.formatCanisterLocation(x.canisterLocation)}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${(x.name==null || x.name == '')? ((x.customerDrugName != null && x.customerDrugName != '')? x.customerDrugName : ''): x.name}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${ x.strength == null? '':  x.strength}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.manufacturer == null? '': x.manufacturer}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.ndc == null? '': x.ndc}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.customerDrugNdc == null? '': x.customerDrugNdc}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.atpCanisterNumber == null? '': x.atpCanisterNumber}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.otcOrVitamin == null? '':x.otcOrVitamin}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.canisterCapacity == null? '':x.canisterCapacity}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.drawerType ??  ''}</Data>
      </Cell> 
     </Row>`
      })
      let concatenatedTableData = tableData.join('');
      let totalRow = 27 + tableRow;

    let xml = `<?xml version="1.0" encoding="utf-8"?><?mso-application progid="Excel.Sheet"?><Workbook xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:x2="urn:schemas-microsoft-com:office:excel2" xmlns:html="http://www.w3.org/TR/REC-html40" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882">
    <x:ExcelWorkbook>
     <x:ActiveSheet>0</x:ActiveSheet>
    </x:ExcelWorkbook>
    <Styles>
     <Style ss:ID="Default" ss:Name="Normal">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Font ss:Color="#000000" ss:FontName="Calibri" ss:Size="11" />
     </Style>
     <Style ss:ID="S21">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Font  ss:FontName="Calibri" ss:Size="11" />
     </Style>
     <Style ss:ID="S22">
      <ss:Alignment ss:Vertical="Bottom" />
       <ss:Borders>
       <ss:Border ss:Position="Left" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
       <ss:Border ss:Position="Top" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
         <ss:Border ss:Position="Right" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
           <ss:Border ss:Position="Bottom" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
      </ss:Borders>
      <ss:Font  ss:FontName="Calibri"  ss:Size="11" />
      <ss:Interior ss:Color="#A9A9A9" ss:Pattern="Solid" />
     </Style>
     <Style ss:ID="S23">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Borders>
       <ss:Border ss:Position="Left" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
       <ss:Border ss:Position="Top" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
         <ss:Border ss:Position="Right" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
           <ss:Border ss:Position="Bottom" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
      </ss:Borders>
      <ss:Font ss:FontName="Calibri" ss:Size="11" />
     </Style>



      <Style ss:ID="S24">
      <ss:Alignment ss:Vertical="Bottom"  ss:WrapText="1"/>
      <ss:Borders>
       <ss:Border ss:Position="Left" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
       <ss:Border ss:Position="Top" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
         <ss:Border ss:Position="Right" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
           <ss:Border ss:Position="Bottom" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
      </ss:Borders>
      <ss:Font ss:FontName="Calibri" ss:Size="11" />
        <ss:Interior ss:Color="#A9A9A9" ss:Pattern="Solid" />
     </Style>

     <Style ss:ID="HyperlinkStyle">
       <Font ss:Color="#0000FF" ss:Underline="Single" />
     </Style>

     <Style ss:ID="S54">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Borders>
       <ss:Border ss:Position="Left" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
       <ss:Border ss:Position="Top" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
       <ss:Border ss:Position="Right" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
       <ss:Border ss:Position="Bottom" ss:Color="#000000" ss:LineStyle="Continuous" ss:Weight="1" />
      </ss:Borders>
      <ss:Font ss:FontName="Calibri" ss:Background = "#FFD733" ss:Bold="1" ss:Size="12" />
     </Style>
    </Styles>

    <Worksheet ss:Name="Canister Order">
     <ss:Names />
     <ss:Table ss:DefaultRowHeight="15.75" ss:DefaultColumnWidth="54" ss:ExpandedRowCount="${26+totalRow}" ss:ExpandedColumnCount="11">
      <Column ss:Index="1" ss:AutoFitWidth="0" ss:Width="110.75" />
      <Column ss:Index="2" ss:AutoFitWidth="0" ss:Width="110.75" />
      <Column ss:Index="3" ss:AutoFitWidth="0" ss:Width="160.5" />
      <Column ss:Index="4" ss:AutoFitWidth="0" ss:Width="110.25" />
      <Column ss:Index="5" ss:AutoFitWidth="0" ss:Width="110" />
      <Column ss:Index="6" ss:AutoFitWidth="0" ss:Width="110.5" />
       <Column ss:Index="7" ss:AutoFitWidth="0" ss:Width="110.5" />
        <Column ss:Index="8" ss:AutoFitWidth="0" ss:Width="110.5" />
         <Column ss:Index="9" ss:AutoFitWidth="0" ss:Width="110.5" />
          <Column ss:Index="10" ss:AutoFitWidth="0" ss:Width="110.5" />
           <Column ss:Index="11" ss:AutoFitWidth="0" ss:Width="110.5" />
      <Row ss:Index="1" ss:Height="20.25">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Customer Name:</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String">${this.customerName}</Data></Cell>
       <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="2">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Customer Number:</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String">${this.CustomerNumber}</Data>
       </Cell>
      <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="3">
  <Cell ss:StyleID="S22">
    <Data ss:Type="String">IPR Case:</Data>
  </Cell>
  <Cell ss:StyleID="HyperlinkStyle" ${this.caseLink ? `ss:HRef="${this.caseLink}"` : ""}>
    <Data ss:Type="String">${this.caseNumber}</Data>
  </Cell>
  <Cell />
  <Cell />
  <Cell />
  <Cell />
  <Cell />
</Row>
      <Row ss:Index="4">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Machine & Size:</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String">${this.subDeviceTypeName}</Data>
       </Cell>
        <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="5">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Multiple Machines?</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String"></Data> </Cell>
        <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="6">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Smart Canisters?</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String">${this.smartCanisters}</Data> </Cell>
       <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="7" ss:Height="36.75" >
       <Cell ss:StyleID="S24"><Data ss:Type="String">Need Canisters Delivered By:</Data>
       </Cell>
       <Cell ss:StyleID="S23" />
      <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="8" ss:Height="20.25">
       <Cell ss:StyleID="S22"><Data ss:Type="String">AVF/CCK?</Data>
       </Cell>
        <Cell ss:StyleID="S23">
        <Data ss:Type="String"></Data> </Cell>
       <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="9">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Special Instructions:</Data> </Cell>
       <Cell ss:StyleID="S23" />
     <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="10">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Site Contact Name: </Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String"></Data> </Cell>
       <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="11">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Site Address:</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String">${this.ShippingStreet}, ${this.ShippingCity}, ${this.ShippingState}, ${this.ShippingPostalCode}</Data> </Cell>
        <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="12">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Site Phone Number:</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String"></Data> </Cell>
        <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
       <Row ss:Index="13">
       <Cell ss:StyleID="S22" />
       <Cell ss:StyleID="S23" />
        <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="14">
       <Cell ss:StyleID="S22"><Data ss:Type="String">Desiccants:</Data>
       </Cell>
       <Cell ss:StyleID="S23"><Data ss:Type="String">${this.dessicant}</Data> </Cell>
       <Cell />
        <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
      </Row>
      <Row ss:Index="15">
      <Cell />
      <Cell />
      <Cell />
      <Cell />
      <Cell />
       <Cell />
      <Cell />
      </Row>
      <Row ss:Index="16">
      <Cell />
      <Cell />
      <Cell />
      <Cell />
      <Cell />
       <Cell />
      <Cell />
      </Row>
      <Row ss:Index="17">
      <Cell />
      <Cell />
      <Cell />
      <Cell />
      <Cell />
       <Cell />
      <Cell />
      </Row>
      <Row ss:Index="18">
      <Cell />
      <Cell />
      <Cell />
      <Cell />
      <Cell />
       <Cell />
      <Cell />
      </Row>
      <Row ss:Index="19">
      <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
        <Cell />
       <Cell />
      </Row>
      <Row ss:Index="20">
        <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
        <Cell />
       <Cell />
      </Row>
      <Row ss:Index="21">
       <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
        <Cell />
       <Cell />
      </Row>
      <Row ss:Index="22" ss:Height="20.25">
      <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
        <Cell />
       <Cell />
      </Row>
      <Row ss:Index="23">
      <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
        <Cell />
       <Cell />
      </Row>
      <Row ss:Index="24">
     <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
        <Cell />
       <Cell />
      </Row>
       <Row ss:Index="25">
     <Cell />
       <Cell />
       <Cell />
       <Cell />
       <Cell />
        <Cell />
       <Cell />
      </Row>
      <Row ss:Index="26">
      <Cell ss:StyleID="S22"> <Data ss:Type="String">NDC-9</Data> </Cell>
        <Cell ss:StyleID="S22"> <Data ss:Type="String">Canister </Data> </Cell>
        <Cell ss:StyleID="S22"> <Data ss:Type="String">Drug Name</Data> </Cell>
       <Cell ss:StyleID="S22"> <Data ss:Type="String">Strength</Data> </Cell>
       <Cell ss:StyleID="S22"> <Data ss:Type="String">Manufacturer</Data> </Cell>
        <Cell ss:StyleID="S22"> <Data ss:Type="String">NDC-11</Data> </Cell>
       <Cell ss:StyleID="S22"> <Data ss:Type="String">CustomerNDC</Data> </Cell>
        <Cell ss:StyleID="S22"> <Data ss:Type="String">Citem#</Data> </Cell>
         <Cell ss:StyleID="S22"> <Data ss:Type="String">OTC/VIT</Data> </Cell> 
         <Cell ss:StyleID="S22"> <Data ss:Type="String">Canister Capacity</Data> </Cell>
         <Cell ss:StyleID="S22"> <Data ss:Type="String">Canister Type</Data> </Cell>
      </Row>
      ${concatenatedTableData}
     </ss:Table>
     <WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">
      <PageSetup>
       <Header x:Margin="0.3" />
       <Footer x:Margin="0.3" />
       <PageMargins x:Top="0.75" x:Bottom="0.75" x:Left="0.7" x:Right="0.7" />
      </PageSetup>
      <Print>
       <PaperSizeIndex>9</PaperSizeIndex>
       <HorizontalResolution>600</HorizontalResolution>
       <VerticalResolution>600</VerticalResolution>
      </Print>
     </WorksheetOptions>
    </Worksheet>

   </Workbook>`
    const base64 = function(s:any) { return window.btoa(unescape(encodeURIComponent(s))) };
    const link = document.createElement('a');
    const uri = 'data:application/vnd.ms-excel;base64,';
    link.download =`Canister Order XLSX-${this.customerName}-${this.deviceName}-${this.subDeviceTypeName || ""}- ${
      this.getCurrentDate()
     }.xls`;
    link.href =  uri + base64(xml);
    link.click();
  }

  excelExportFromAtpTable() {
    const allDrugs = [
      ...this.analysisDrugList,
      ...this.notAvailableDrugList,
      ...this.excludedDrugList,
      ...this.notOralDrugList,
    ];

    const exportRows = allDrugs.map((x: any) => this.mapForCapsExportRow(x));

    // Export requires one row per unique NDC.
    this.analysisDrugListCsv = exportRows.filter(
      (row, index, self) => index === self.findIndex((d) => d.drug_number === row.drug_number)
    );

    this.fileInfo = {
      fileName: this.getForCapsExportFileName(),
      templates: [
        {
          data: this.analysisDrugListCsv,
          sheetName: 'Analysis'
        },
      ]
    };
    this.exportService.exportAsCSVFile(this.fileInfo);
  }

  private normalizeQsqrColumnValues(column: any): string {
    return column == null ? '' : column.toString().toLowerCase();
  }

  private mapForCapsExportRow(drug: any): any {
    const ndc11 = this.toElevenDigitNdc(drug?.ndc);
    const drugNumber = `^${ndc11}`;
    const scheduleOtc = this.mapScheduleToOtcCode(drug?.schedule);
    const nioshCode = this.mapNioshCode(drug?.niosh ?? drug?.Niosh);
    const sanitizedBarcode = this.sanitizeCsvValue(drug?.barcode ?? '');
    const upcValue = sanitizedBarcode.length > 0
      ? `^${sanitizedBarcode}`
      : `^999999999999-${ndc11}`;

    const genericNameIndicator = this.toBoolean(drug?.genericNameIndicator);
    const genericOrDrugName = genericNameIndicator
      ? (drug?.genericName ?? drug?.primaryDrugName ?? drug?.customerDrugName ?? drug?.name ?? '')
      : (drug?.name ?? drug?.customerDrugName ?? drug?.primaryDrugName ?? drug?.genericName ?? '');

    const reminder = this.buildReminder(drug);
    const inventoryValue = drug?.customerInventoryNumber && drug.customerInventoryNumber.toString().trim().length > 0
      ? drug.customerInventoryNumber
      : ndc11;

    const colorAbbr = this.sanitizeCsvValue(drug?.color ?? '');
    const shapeAbbr = this.sanitizeCsvValue(drug?.shape ?? '');
    const formAbbr = this.sanitizeCsvValue(drug?.form ?? '');
    const abbrCombined = `${colorAbbr}/${shapeAbbr}/${formAbbr}`;

    return {
      drug_number: drugNumber,
      mnemonic: `^${this.sanitizeCsvValue(drug?.mnemonic ?? '')}`,
      UPC: upcValue,
      generic_name: this.sanitizeCsvValue(genericOrDrugName),
      commercial_name: this.sanitizeCsvValue(genericOrDrugName),
      manufacturer: this.sanitizeCsvValue(drug?.manufacturer ?? ''),
      Strength: '',
      reminder: reminder,
      dosage_form: this.sanitizeCsvValue(drug?.dosageForm ?? ''),
      Volume: 0,
      Lot: '',
      MFGExpiration: '',
      QTYinCanister: '',
      color: this.sanitizeCsvValue(drug?.fullColorName ?? drug?.color ?? ''),
      shape: this.sanitizeCsvValue(drug?.fullShapeName ?? drug?.shape ?? ''),
      'imprint1/imprint2': this.sanitizeCsvValue(drug?.imprint ?? drug?.marking ?? ''),
      '*_abbr columns': abbrCombined,
      pack_size: this.sanitizeCsvValue(drug?.packQuantity ?? ''),
      'Cost Per Pill': '',
      weight: this.formatWeight(drug?.weight),
      'schedule otc': scheduleOtc,
      Comment: '',
      pack_alone: '',
      Active: '',
      Min: 0,
      Max: this.toNumberOrZero(drug?.max),
      local_inventory_number: `^${inventoryValue}`,
      'Smart ID': '',
      equivalence: this.sanitizeCsvValue(drug?.genericSequenceNumber ?? ''),
      'Assigned Lot': '',
      'Assigned Expiration': '',
      Distributor: '',
      PackageVolume: '',
      Priority: '',
      Image: '',
      scoring: this.sanitizeCsvValue(drug?.scoring ?? ''),
      ColdPackDictId: '',
      route_of_administration: this.sanitizeCsvValue(drug?.routeOfAdministration ?? ''),
      uom: this.sanitizeCsvValue(drug?.uom ?? ''),
      strength: this.sanitizeCsvValue(drug?.str ?? ''),
      niosh: nioshCode,
      image: ''
    };
  }

  private getForCapsExportFileName(): string {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const storeName = this.normalizeStoreName(this.customerName);
    return `${storeName}_${yyyy}${mm}${dd}_${hh}${min}_DrugUpdate_forcaps`;
  }

  private normalizeStoreName(storeName: string): string {
    if (!storeName || storeName.trim().length === 0) {
      return 'Store';
    }
    return storeName.trim().replace(/\s+/g, '_');
  }

  private toElevenDigitNdc(ndc: any): string {
    const digits = (ndc ?? '').toString().replace(/\D/g, '');
    if (digits.length === 11) {
      return digits;
    }
    if (digits.length > 11) {
      return digits.substring(0, 11);
    }
    return digits.padStart(11, '0');
  }

  private splitStrength(strength: any): { strengthValue: string; uom: string } {
    const raw = (strength ?? '').toString().trim();
    if (!raw) {
      return { strengthValue: '', uom: '' };
    }

    const numberMatch = raw.match(/[0-9]+(?:\.[0-9]+)?/);
    const strengthValue = numberMatch ? numberMatch[0] : '';

    let lastNumericDigitIndex = -1;
    for (let i = raw.length - 1; i >= 0; i--) {
      if (/[0-9]/.test(raw[i])) {
        lastNumericDigitIndex = i;
        break;
      }
    }

    const uom = lastNumericDigitIndex >= 0
      ? raw.substring(lastNumericDigitIndex + 1).trim()
      : '';

    return { strengthValue, uom };
  }

  private sanitizeCsvValue(value: any): string {
    if (value == null) {
      return '';
    }
    return value.toString().replace(/,/g, ' ').trim();
  }

  private formatWeight(value: any): string {
    const raw = (value ?? '').toString().trim();
    const numericToken = raw.match(/-?[0-9]+(?:\.[0-9]+)?/);
    const parsed = numericToken ? Number(numericToken[0]) : Number(value);
    const fixed = Number.isFinite(parsed) ? parsed.toFixed(3) : '0.000';

    // Export as text so Excel does not trim trailing zeros from CSV numeric values.
    return `="${fixed}"`;
  }

  private mapScheduleToOtcCode(schedule: any): string {
    const value = (schedule ?? '').toString().trim().toUpperCase();
    const scheduleMap: Record<string, string> = {
      'RX': '0',
      'C-I': '1',
      'C-II': '2',
      'C-III': '3',
      'C-IV': '4',
      'C-V': '5',
      'OTC': 'OTC'
    };
    return scheduleMap[value] ?? '';
  }

  private buildReminder(drug: any): string {
    const isOralSolid = this.toBoolean(drug?.isOralSolid);
    const dnuMax = this.toBoolean(drug?.dnuMaxForExclusion ?? drug?.dnu_max);
    const niosh = (drug?.niosh ?? drug?.Niosh ?? '').toString().trim().toLowerCase();
    if (!isOralSolid || dnuMax || niosh.includes('table 1')) {
      return 'ext';
    }
    return '';
  }

  private mapNioshCode(value: any): string {
    const niosh = (value ?? '').toString().toLowerCase();
    if (niosh.includes('table 1')) {
      return '1';
    }
    if (niosh.includes('table 2')) {
      return '2';
    }
    return '';
  }

  private toBoolean(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (value == null) {
      return false;
    }
    const normalized = value.toString().trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'y' || normalized === 'yes';
  }

  private toNumberOrZero(value: any): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

   formatCanisterLocation(canisterLocation) {
    // Return empty string for null, undefined, empty, "000", or "DCR" values
    if (!canisterLocation || canisterLocation === '000' || canisterLocation === 'DCR' || canisterLocation === '0') {
      return '';
    }
    
    let locationString = canisterLocation.toString();
    let formattedCanisterLocation = locationString.padStart(3, '0');
    
    // After padding, check if it becomes "000" and return empty string
    if (formattedCanisterLocation === '000') {
      return '';
    }
    
     let assetNumber = (this.AssetNumber || '').toString().padStart(6, '0');
    
    return assetNumber + formattedCanisterLocation;
}


  customerDrugExport() {
    let customerDrugData: any[] = [];
    let newDrugData: any[] = [];
    let excludedDrugData: any[] = [];
    let notOralDrugData: any[] = [];

    this.analysisDrugList.forEach(x => {
      customerDrugData.push({
        'NDC': x.ndc,
        'Customer Drug Id': x.customerDrugNdc,
        'Barcode':  x.barcode && x.barcode.length > 0 ? '^' + x.barcode : '',
        'Primary Drug Name': x.primaryDrugName,
        'Secondary Drug Name': x.secondaryDrugName,
        'Strength': x.strength,
        'Location': this.formatCanisterLocation(x.canisterLocation),
        'Pill Form': x.pillForm,
        'Volume': x.volume,
        'Lot': x.lot,
        'QtyInCanister': x.qtyInCanister,
        '#CItem': x.atpCanisterNumber,
        'Color': x.color,
        'Shape': x.shape,
        'Marking': x.marking,
        'PackQuantity': x.packQuantity,
        'APW': x.apw,
        'Active': x.active,
        'Generic Number': x.genericSequenceNumber,
        'Unit Usage': x.usage,
        'Drawer': x.drawer,
        'Drawer Type': x.drawerType,
        '30 Dram': x.thirtyDramCapacity,
        'Pill Volume': x.pillVolume,
        'EXP Date': '',
        'IsUnRegulated': x.isUnregulated,
      })
    })


    this.notAvailableDrugList.forEach(x => {
      newDrugData.push({
        'NDC': x.ndc,
        'Customer Drug Id': x.customerDrugNdc,
        'Barcode': x.barcode,
        'Primary Drug Name': x.primaryDrugName,
        'Secondary Drug Name': x.secondaryDrugName,
        'Strength': x.strength,
        'Location': this.formatCanisterLocation(x.canisterLocation),
        'Pill Form': x.pillForm,
        'Volume': x.volume,
        'Lot': x.lot,
        'QtyInCanister': x.qtyInCanister,
        '#CItem': x.atpCanisterNumber,
        'Color': x.color,
        'Shape': x.shape,
        'Marking': x.marking,
        'PackQuantity': x.packQuantity,
        'APW': x.apw,
        'Active': x.active,
        'Generic Number': x.genericSequenceNumber,
        'Unit Usage': x.usage,
        'Drawer': x.drawer,
        'Drawer Type': x.drawerType,
        '30 Dram': x.thirtyDramCapacity,
        'Pill Volume': x.pillVolume,
        'EXP Date': '',
        'IsUnRegulated': x.isUnregulated,
      })
    })

    this.excludedDrugList.forEach(x => {
      excludedDrugData.push({
        'Excluded Reason':x.excludedReason,
        'NDC': x.ndc,
        'Customer Drug Id': x.customerDrugNdc,
        'Barcode': x.barcode,
        'Primary Drug Name': x.primaryDrugName,
        'Secondary Drug Name': x.secondaryDrugName,
        'Strength': x.strength,
        'Location': this.formatCanisterLocation(x.canisterLocation),
        'Pill Form': x.pillForm,
        'Volume': x.volume,
        'Lot': x.lot,
        'QtyInCanister': x.qtyInCanister,
        '#CItem': x.atpCanisterNumber,
        'Color': x.color,
        'Shape': x.shape,
        'Marking': x.marking,
        'PackQuantity': x.packQuantity,
        'APW': x.apw,
        'Active': x.active,
        'Generic Number': x.genericSequenceNumber,
        'Unit Usage': x.usage,
        'Drawer': x.drawer,
        'Drawer Type': x.drawerType,
        '30 Dram': x.thirtyDramCapacity,
        'Pill Volume': x.pillVolume,
        'EXP Date': '',
        'IsUnRegulated': x.isUnregulated,
      })
    })

    this.notOralDrugList.forEach(x => {
      notOralDrugData.push({
        'NDC': x.ndc,
        'Customer Drug Id': x.customerDrugNdc,
        'Barcode': x.barcode,
        'Primary Drug Name': x.primaryDrugName,
        'Secondary Drug Name': x.secondaryDrugName,
        'Strength': x.strength,
        'Location': this.formatCanisterLocation(x.canisterLocation),
        'Pill Form': x.pillForm,
        'Volume': x.volume,
        'Lot': x.lot,
        'QtyInCanister': x.qtyInCanister,
        '#CItem': x.atpCanisterNumber,
        'Color': x.color,
        'Shape': x.shape,
        'Marking': x.marking,
        'PackQuantity': x.packQuantity,
        'APW': x.apw,
        'Active': x.active,
        'Generic Number': x.genericSequenceNumber,
        'Unit Usage': x.usage,
        'Drawer': x.drawer,
        'Drawer Type': x.drawerType,
        '30 Dram': x.thirtyDramCapacity,
        'Pill Volume': x.pillVolume,
        'EXP Date': '',
        'IsUnRegulated': x.isUnregulated,
      })
    })

    this.fileInfo = {
      fileName: `Customer Drug XLSX-${this.customerName}-${this.deviceName}-${this.subDeviceTypeName || ""}- ${
        this.getCurrentDate()
       }.xlsx`,
      templates:
        [
          {
            data: customerDrugData,
            sheetName: 'Customer Drugs'
          },
          {
            data: newDrugData,
            sheetName: 'New Drugs'
          },
          {
            data: excludedDrugData,
            sheetName: 'Excluded'
          },
          {
            data: notOralDrugData,
            sheetName: 'Non-Oral Solid'
          }
        ]
    }
    this.exportService.exportAsExcelFile(this.fileInfo);
  }

  onAllUserPaginateChange() {
    const matTable = document.getElementById('matTable');
    matTable.scrollIntoView();
  }

  allSelectedDrugUnchecked() {
    if (this.drugCellLocationList.length > 0) {
      for (let i = 0; i < this.drugCellLocationList.length; i++) {
        let index = this.dataSource.data.findIndex(
          (x) => x.fileUploadDrugId == this.drugCellLocationList[i].fileUploadDrugId
        );
        this.dataSource.data[index].checked = false;
      }
      this.drugCellLocationList = [];
    }
  }

  drugCellLocationChecked(row: any, isChecked: boolean) {
    if (this.ndcOfMultippleLocation?.indexOf(row.customerDrugNdc) !== -1) {
      this.isMultipleCellLocation = true;
    }

    if (isChecked) {
      this.drugCellLocationList.push({
        fileUploadDrugId: row.fileUploadDrugId,
        canisterLocation: row.canisterLocation,
        drawerType: row.drawerType,
        drugName: row.customerDrugName,
        processDrugAtpId: row.processDrugAtpId
      });
      this.isAnyDrugSelected = true;
    } else {
      row.canisterLocation = row.cellLocOld;
      let index = this.drugCellLocationList.findIndex(
        (x) => x.fileUploadDrugId == row.fileUploadDrugId
      );
      this.drugCellLocationList.splice(index, 1);
      if (this.drugCellLocationList.length == 0) {
        this.isAnyDrugSelected = false;
      }
    }
  }

  getAvailableCellLocation(customerId: string) {

    const ATPDRUGDATAAVAILABEL_KEY = 'Atpdrugavailablecelllocation'
    this.ngxLoader.start(ATPDRUGDATAAVAILABEL_KEY)
    this.imtoolAtpService.getAvailableCellLocationAtpCaps(customerId).subscribe(
      (response) => {
        let result = response.data;
        this.ngxLoader.stop(ATPDRUGDATAAVAILABEL_KEY);
        result?.forEach((x) => {
          this.celLogList.push({
            id: x.cellLoc,
            value: x.cellLoc,
          });
        });
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.ngxLoader.stop(ATPDRUGDATAAVAILABEL_KEY);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );

  }

  drugCellLocationChanged(row: any) {

    if (!this.isAlreadyCellLocationUsed(row)) {
      for (let i = 0; i < this.drugCellLocationList.length; i++) {
        if (
          this.drugCellLocationList[i].fileUploadDrugId == row.fileUploadDrugId
        ) {
          this.drugCellLocationList[i].canisterLocation = row.canisterLocation;
          break;
        }
      }
    }
  }

  isAlreadyCellLocationUsed(row: any): boolean {
    for (let i = 0; i < this.drugCellLocationList.length; i++) {
      if (this.drugCellLocationList[i].canisterLocation == row.canisterLocation) {
        this.toastService.openToast(
          `drug (${this.drugCellLocationList[i].drugName}) already used this cell location`,
          constants.ToastPanelType.warning,
          2
        );
        this.replaceTheOldCellLocation(row);
        return true;
      }
    }
    return false;
  }



  openAleftWizardForValidateDrug(row: any) {

    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: 'Unoccupied Space Warning',
        bodyMessage: 'Are you sure you want to add a regular cell drug to a Super cell location',
        bodyMessage2: "",
        cancelBtnText: "Cancel",
        confirmBtnText: "Ok",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result.data) {
        this.replaceTheOldCellLocation(row);
      }
    });
  }


  replaceTheOldCellLocation(row: any) {
    let index = this.dataSource.data.findIndex(
      (x) => x.ndc == row.ndc
    );
    this.dataSource.data[index].cellLoc = row.cellLocOld;
    index = this.drugCellLocationList.findIndex((x) => x.fileUploadDrugId == row.fileUploadDrugId)
    this.drugCellLocationList[index].canisterLocation = row.cellLocOld;
  }



  getCurrentTabSelect(tab: any) {
    this.updateMainDataSourceArray(this.tabSelected);
    this.tabSelected = tab.index;
    this.drugCellLocationList = [];
  }
  updateMainDataSourceArray(tab: number) {
    if (tab === 0) {
      this.getTheSelectedDrugList().forEach(x => {
        let index = this.dataSource.data.findIndex(y => y.processDrugAtpId == x)
        this.dataSource.data[index].checked = false;
        this.isAnyDrugSelected = false;
      });
    }
    else if (tab === 1) {
      this.getTheSelectedDrugList().forEach(x => {
        let index = this.dataSourceNotAbailable.data.findIndex(y => y.processDrugAtpId == x)
        this.dataSourceNotAbailable.data[index].checked = false;
      });
    }
    else if (tab === 2) {
      this.getTheSelectedDrugList().forEach(x => {
        let index = this.dataSourceExcluded.data.findIndex(y => y.processDrugAtpId == x)
        this.dataSourceExcluded.data[index].checked = false;
      });
    }

    else if (tab === 3) {
      this.getTheSelectedDrugList().forEach(x => {
        let index = this.dataSourceOral.data.findIndex(y => y.processDrugAtpId == x)
        this.dataSourceOral.data[index].checked = false;
      });
    }

  }

  getTheSelectedDrugList(): number[] {
    return this.drugCellLocationList.map((x) => x.processDrugAtpId)
  }

  downloadFile(data: number) {
    if (data == 1 || data == 2 || data == 3) {
      this.openAlertWindow(data);
    }
    else if (data == 4) {
      this.downloadXML();
    }
  }

  ExportTOExcel() {
    this.ngxLoader.start();
    setTimeout(() => {
      this.changeStatusToExport();
      this.ngxLoader.stop();
    }, 3000)
  }

  OBJtoXML(obj) {
    var xml = '';
    for (var prop in obj) {
      xml += obj[prop] instanceof Array ? '' : "\n<" + prop + ">";

      if (obj[prop] instanceof Array) {
        var arr =obj[prop];
        for (var i = 0; i < arr.length; i++) {
        xml += "\n<" + prop + ">";
        xml += this.OBJtoXML(new Object(arr[i]));
        xml += "\n</" + prop + ">";
        if (i === arr.length - 1) {
          xml += "\n";
        }
      }

      } else if (typeof obj[prop] == "object") {
        xml +=  this.OBJtoXML(new Object(obj[prop]));
      } else {
        xml += obj[prop];
      }
      xml += obj[prop] instanceof Array ? '' : "</" + prop + ">";
    }
    var xml = xml.replace(/<\/?[0-9]{1,}>/g, '');

    return xml
  }
  downloadXML() {
    // analysis drug list
    var fileContents, fileName;

    fileContents = this.OBJtoXML(this.xmlAnalysisFormatData);
    const today = new Date();
    const yyyyMMdd = today.toISOString().slice(0, 10).replace(/-/g, '');
    // e.g. "20260811"

    // Format time as HHMM (24-hour clock)
    const hhmm = today.getHours().toString().padStart(2, '0') +
      today.getMinutes().toString().padStart(2, '0');

    fileName = `${this.customerName}_${yyyyMMdd}_${hhmm}_CanisterUpdate_forcaps.xml`;
    var pp = document.createElement('a');
    pp.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(fileContents.trimStart().replace('<ArrayOfMedication>', MedicationXMLBrand)));
    pp.setAttribute('download', fileName);
    pp.click();

  }

  ExportCustomerDrug() {
    this.ngxLoader.start();
    setTimeout(() => {
      this.customerDrugExport();
      this.changeStatusToExport();
      this.ngxLoader.stop();
    }, 1000)
  }



  changeStatusToExport() {
    this.ngxLoader.start();
    this.imtoolService.changeStatusToExport(this.customerId).subscribe(
      (result) => {
        this.ngxLoader.stop();
        if (result.statusCode == 200) {
          this.toastService.openToast(
            `Downloaded Successfully. ${result.message}`,
            constants.ToastPanelType.done,
            2
          );
        } else {
          this.toastService.openToast(
            result.message,
            constants.ToastPanelType.error,
            2
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }
  getRecommendedDrugData(customerId, cellSize) {
    this.currentFilterSize = cellSize;

    const ATPDRUGDATA_KEY = 'Atpdrugdatakey'
    this.ngxLoader.start(ATPDRUGDATA_KEY)
    this.xmlAnalysisFormatData = new MedicationXml();
    this.imtoolService.getRecommendedDrugData(customerId, cellSize).subscribe(
      (response) => {
        let result = response.data
        if (result == null) {
          this.ngxLoader.stop(ATPDRUGDATA_KEY);
          this.toastService.openToast(
            response.message,
            constants.ToastPanelType.error,
            2
          );

        };
        this.orderOrUsage = result.orderOrUsage == true ? '# of Orders' : 'Pills Disp';
        this.phllDispLable = result.orderOrUsage == true ? 'Pills Disp' : '# of Orders';
        console.log(result.arrayOfMedication)
       if(result.arrayOfMedication != null){
        result.arrayOfMedication.medications.forEach((element) => {
          this.xmlAnalysisFormatData.ArrayOfMedication.Medication.push({
            ndc: element.ndc,
            parlevel: element.parlevel,
              custNdc: element.custNdc,
              barcode: element.barcode,
              genericName: element.genericName,
              brandName: element.brandName,
              manufacturer: element.manufacturer,
              strength: element.strength,
              pillForm: element.pillForm,
              volume: element.volume,
              color: element.color,
              shape: element.shape,
              marking: element.marking,
              description: element.description,
              packQuantity: element.packQuantity,
              costPerPill: element.costPerPill,
              weight: null,
              drugControlLevelDictId: element.drugControlLevelDictId,
              comment: element.comment,
              doNotMix: element.doNotMix,
              active: element.active,              
              maxParLevel: element.maxParLevel,
              inventoryNumber: element.inventoryNumber,
              gcn_seqNo: element.gcn_seqNo,
              distributor: element.distributor,
              ndcid: element.ndcid,
              drugid: element.drugid,
              manufacturerid: element.manufacturerid,
              dispLocTypeDictId: element.dispLocTypeDictId,
              packageVolume: element.packageVolume,
              priority: element.priority,
              image: element.image,
              score: element.score,
              coldPackDictId: element.coldPackDictId,
              drugDoseFormDictId: element.drugDoseFormDictId,
              dispLoc: {
                DispLocation: element.dispLoc.map(dispLocElement => ({
                    smartId: dispLocElement.smartId,
                    canNumber: result.assetNumber + dispLocElement.canNumber,
                    dispLocDictId: dispLocElement.dispLocDictId,
                    lotNumber: dispLocElement.lotNumber,
                    expDate: dispLocElement.expDate,
                    canQty: dispLocElement.canQty,
                    aLotNumber: dispLocElement.aLotNumber,
                    aExpDate: dispLocElement.aExpDate,
                    active: dispLocElement.active,
                    dispenselocationid: '',
                    clusterCanStatusDictID: dispLocElement.clusterCanStatusDictID
                }))
            }
          });
      });

       }
        this.customerName = result.customerName;
        this.targetInstallDate = result.targetInstallDate;
        this.subDeviceTypeName = result.deviceTypeName;
        this.deviceId = result.deviceId;
        this.deviceName = result.deviceName;
        this.primaryLabelName = "Primary Drug Name";
        this.secondaryLabelName = "Secondary Drug Name";
        this.smartCount = result.smartCount;
        this.highCapCount = result.highCapCount;
        this.smartHighCapCount = result.smartHighCapCount;
        this.regularCount = result.regularCount;
        this.noDrawerCount = result.remainingCount;
        this.remainingSmartHighCapCount = result.remainingSmartHighCapCount;
        this.remainingSmartCount = result.remainingSmartCount;
        this.remainingRegularCount = result.remainingRegularCount;
        this.caseNumber = result.caseNumber;
        this.CustomerNumber = result.customerNumber || "";
        this.AssetNumber = result.assetNumber || "";
        this.ShippingCity = result.shippingCity;
        this.AccountNumber = result.accountNumber;
        this.ShippingStreet = result.shippingStreet;
        this.ShippingState = result.shippingState;
        this.ShippingPostalCode = result.shippingPostalCode;
        this.smartCanisters = this.smartCount > 0 ? "TRUE" : "FALSE";
        this.dessicant = this.dessicantsMapping[this.subDeviceTypeName] || "";
        this.caseId = result.caseId;
        if (this.caseId) {
          this.caseLink = `https://paratasso.lightning.force.com/lightning/r/Case/${this.caseId}/view`;
        } else {
          this.caseLink = "";
        }



        this.analysisDrugList = [];
        this.notAvailableDrugList = [];
        this.excludedDrugList = [];
        this.notOralDrugList = [];
        this.cellLocatorSheetList = [];

        let rowSerial = 1;
        result.drugs?.forEach((x) => {
          if (x.canisterLocation !== undefined || x.canisterLocation !== null) {
            if (x.canisterLocation?.indexOf(',') > -1) {
              var location_array = x.canisterLocation.split(',');
              this.ndcOfMultippleLocation.push(x.customerDrugNdc);

              for (var i = 0; i < location_array.length; i++) {
                let lcoation = Number(location_array[i]);
                this.analysisDrugList.push({
                  checked: false,
                  topOrder: x.topOrder,
                  processDrugAtpId: x.processDrugAtpId,
                  processDrugType: x.processDrugType,
                  fileUploadDrugId: x.processDrugAtpId, // rplace this old code x.fileUploadDrugId,
                  ndc: x.ndc,
                  customerDrugNdc: x.customerDrugNdc.length>0?x.customerDrugNdc:x.ndc,
                  barcode: x.barcode,
                  name: x.name,
                  customerDrugName: x.customerDrugName,
                  mfgExpiration: x.mfgExpiration,
                  strength: x.strength,
                  canisterLocation: location_array[i],
                  pillForm: x.pillForm,
                  volume: x.volume,
                  pillVolume: x.pillVolume,
                  lot: x.lot,
                  qtyInCanister: x.qtyInCanister,
                  color: x.color,
                  shape: x.shape,
                  marking: x.marking,
                  description: x.description,
                  packQuantity: x.packQuantity,
                  costPerPill: x.costPerPill,
                  apw: x.apw,
                  controlSched: x.controlSched,
                  comment: x.comment,
                  doNotMix: x.doNotMix,
                  active: x.active,
                  min: x.min,
                  max: x.max,
                  invoiceNumber: x.invoiceNumber,
                  smartId: x.smartId,
                  genericSequenceNumber: x.genericSequenceNumber,
                  assignedLot: x.assignedLot,
                  assignedExpiration: x.assignedExpiration,
                  distributor: x.distributor,
                  drawerType: x.drawerType,
                  drawer: x.drawer,
                  usage: x.usage,
                  noOfOrder: x.noOfOrder,
                  otc: x.otc,
                  schedule: x.schedule,
                  thirtyDramCapacity: x.thirtyDramCapacity,
                  manufacturer: x.manufacturer,
                  statusForNotOral: x.statusForNotOral,
                  oralSolidStatus: x.oralSolidStatus,
                  nonCountReasonForNotAvailable: x.nonCountReasonForNotAvailable,
                  tab: x.tab,
                  automate: x.automate,
                  excludedReason: x.excludedReason,
                  dnuMaxForExclusion: x.dnuMaxForExclusion,
                  gcValue: x.gcValue,
                  hcGcValue: x.hcGcValue,
                  cellLocOld: x.canisterLocation,
                  atpCanisterNumber: x.atpCanisterNo,
                  primaryDrugName: x.primaryDrugName?.length>0?x.primaryDrugName:x.customerDrugName,
                  secondaryDrugName: x.secondaryDrugName,
                  drugStatus: x.drugStatus,
                  gcnSeqInExport: x.gcnSeqInExport,
                  locationInExport: `^${String(lcoation).padStart(3, '0')}`,
                  locationAnalysis: x.drawerType === 'Smart' ? 'SMART' : location_array[i],
                  customerComment: x.customerComment,
                  customerInventoryNumber: x.customerInventoryNumber,
                  otcOrVitamin: x.otcOrVitamin,
                  canisterCapacity: x.canisterCapacity,
                  isUnregulated: x.isUnregulated,
                  mnemonic: x.mnemonic,
                  genericName: x.genericName,
                  genericNameIndicator: x.genericNameIndicator,
                  fullColorName: x.fullColorName,
                  fullShapeName: x.fullShapeName,
                  imprint: x.imprint,
                  dosageForm: x.dosageForm,
                  weight: x.weight,
                  scoring: x.scoring,
                  routeOfAdministration: x.routeOfAdministration,
                  isOralSolid: x.isOralSolid,
                  niosh: x.niosh,
                  dnu_max: x.dnu_max,
                  str: x.str,
                  uom: x.uom,
                  form: x.form,
                  smartCapCanister:x.smartCapCanister==='y'?'Yes':'No',
                  highCapCanister:x.highCapCanister === 'y'?'Yes':'No'
                });
              }
            }

            else {
              this.analysisDrugList.push({
                checked: false,
                topOrder: x.topOrder,
                processDrugAtpId: x.processDrugAtpId,
                processDrugType: x.processDrugType,
                fileUploadDrugId: x.processDrugAtpId, // rplace this old code x.fileUploadDrugId,
                ndc: x.ndc,
                customerDrugNdc: x.customerDrugNdc.length>0?x.customerDrugNdc:x.ndc,
                barcode: x.barcode,
                name: x.name,
                customerDrugName: x.customerDrugName,
                mfgExpiration: x.mfgExpiration,
                strength: x.strength,
                canisterLocation: x.canisterLocation,
                pillForm: x.pillForm,
                volume: x.volume,
                pillVolume: x.pillVolume,
                lot: x.lot,
                qtyInCanister: x.qtyInCanister,
                color: x.color,
                shape: x.shape,
                marking: x.marking,
                description: x.description,
                packQuantity: x.packQuantity,
                costPerPill: x.costPerPill,
                apw: x.apw,
                controlSched: x.controlSched,
                comment: x.comment,
                doNotMix: x.doNotMix,
                active: x.active,
                min: x.min,
                max: x.max,
                invoiceNumber: x.invoiceNumber,
                smartId: x.smartId,
                genericSequenceNumber: x.genericSequenceNumber,
                assignedLot: x.assignedLot,
                assignedExpiration: x.assignedExpiration,
                distributor: x.distributor,
                drawerType: x.drawerType,
                drawer: x.drawer,
                usage: x.usage,
                noOfOrder: x.noOfOrder,
                otc: x.otc,
                schedule: x.schedule,
                thirtyDramCapacity: x.thirtyDramCapacity,
                manufacturer: x.manufacturer,
                statusForNotOral: x.statusForNotOral,
                oralSolidStatus: x.oralSolidStatus,
                nonCountReasonForNotAvailable: x.nonCountReasonForNotAvailable,
                tab: x.tab,
                automate: x.automate,
                excludedReason: x.excludedReason,
                dnuMaxForExclusion: x.dnuMaxForExclusion,
                gcValue: x.gcValue,
                hcGcValue: x.hcGcValue,
                cellLocOld: x.canisterLocation,
                atpCanisterNumber: x.atpCanisterNo,
                primaryDrugName: x.primaryDrugName?.length>0?x.primaryDrugName:x.customerDrugName,
                secondaryDrugName: x.secondaryDrugName,
                drugStatus: x.drugStatus,
                gcnSeqInExport: x.gcnSeqInExport,
                locationInExport: x.canisterLocation === null || x.canisterLocation === 0 || x.canisterLocation === undefined || x.canisterLocation === "" || x.canisterLocation === 'DCR' || x.canisterLocation ==='Tray' ? '2' : `^${String(x.canisterLocation).padStart(3, '0')}`,
                locationAnalysis: x.drawerType === 'Smart' ? 'SMART' : x.canisterLocation,
                customerComment: x.customerComment,
                customerInventoryNumber: x.customerInventoryNumber,
                otcOrVitamin: x.otcOrVitamin,
                canisterCapacity: x.canisterCapacity,
                isUnregulated: x.isUnregulated,
                mnemonic: x.mnemonic,
                genericName: x.genericName,
                genericNameIndicator: x.genericNameIndicator,
                fullColorName: x.fullColorName,
                fullShapeName: x.fullShapeName,
                imprint: x.imprint,
                dosageForm: x.dosageForm,
                weight: x.weight,
                scoring: x.scoring,
                routeOfAdministration: x.routeOfAdministration,
                isOralSolid: x.isOralSolid,
                niosh: x.niosh,
                dnu_max: x.dnu_max,
                str: x.str,
                uom: x.uom,
                form: x.form,
                smartCapCanister:x.smartCapCanister==='y'?'Yes':'No',
                highCapCanister:x.highCapCanister === 'y'?'Yes':'No'
              });
            }
          }

        });


        rowSerial = 1;
        result.notAvailableDrugs?.forEach((x) => {
          this.notAvailableDrugList.push({
            checked: false,
            topOrder: x.topOrder,
            processDrugAtpId: x.processDrugAtpId,
            processDrugType: x.processDrugType,
            fileUploadDrugId: x.processDrugAtpId, // rplace this old code x.fileUploadDrugId,
            ndc: x.ndc,
            customerDrugNdc: x.customerDrugNdc?.length>0?x.customerDrugNdc:x.ndc,
            barcode: x.barcode,
            name: x.name,
            customerDrugName: x.customerDrugName,
            mfgExpiration: x.mfgExpiration,
            strength: x.strength,
            canisterLocation: x.drawerType === 'Smart' ? 'SMART' : x.canisterLocation,
            pillForm: x.pillForm,
            volume: x.volume,
            pillVolume: x.pillVolume,
            lot: x.lot,
            qtyInCanister: x.qtyInCanister,
            color: x.color,
            shape: x.shape,
            marking: x.marking,
            description: x.description,
            packQuantity: x.packQuantity,
            costPerPill: x.costPerPill,
            apw: x.apw,
            controlSched: x.controlSched,
            comment: x.comment,
            doNotMix: x.doNotMix,
            active: x.active,
            min: x.min,
            max: x.max,
            invoiceNumber: x.invoiceNumber,
            smartId: x.smartId,
            genericSequenceNumber: x.genericSequenceNumber,
            assignedLot: x.assignedLot,
            assignedExpiration: x.assignedExpiration,
            distributor: x.distributor,
            drawerType: x.drawerType,
            drawer: x.drawer,
            usage: x.usage,
            noOfOrder: x.noOfOrder,
            otc: x.otc,
            schedule: x.schedule,
            thirtyDramCapacity: x.thirtyDramCapacity,
            manufacturer: x.manufacturer,
            statusForNotOral: x.statusForNotOral,
            oralSolidStatus: x.oralSolidStatus,
            nonCountReasonForNotAvailable: x.nonCountReasonForNotAvailable,
            tab: x.tab,
            automate: x.automate,
            excludedReason: x.excludedReason,
            dnuMaxForExclusion: x.dnuMaxForExclusion,
            gcValue: x.gcValue,
            hcGcValue: x.hcGcValue,
            cellLocOld: x.canisterLocation,
            atpCanisterNumber: x.atpCanisterNo,
            primaryDrugName: x.primaryDrugName?.length>0?x.primaryDrugName:x.secondaryDrugName,
            secondaryDrugName: x.secondaryDrugName,
            drugStatus: x.drugStatus,
            gcnSeqInExport: x.gcnSeqInExport,
            locationInExport: x.locationInExport,
            locationAnalysis: x.drawerType === 'Smart' ? 'SMART' : x.canisterLocation,
            customerComment: x.customerComment,
            customerInventoryNumber: x.customerInventoryNumber,
            otcOrVitamin: x.otcOrVitamin,
            canisterCapacity: x.canisterCapacity,
            isUnregulated: x.isUnregulated,
                mnemonic: x.mnemonic,
                genericName: x.genericName,
                genericNameIndicator: x.genericNameIndicator,
                fullColorName: x.fullColorName,
                fullShapeName: x.fullShapeName,
                imprint: x.imprint,
                dosageForm: x.dosageForm,
                weight: x.weight,
                scoring: x.scoring,
                routeOfAdministration: x.routeOfAdministration,
                isOralSolid: x.isOralSolid,
                niosh: x.niosh,
                dnu_max: x.dnu_max,
                str: x.str,
                uom: x.uom,
                form: x.form,
                smartCapCanister:x.smartCapCanister==='y'?'Yes':'No',
                highCapCanister:x.highCapCanister === 'y'?'Yes':'No'
          });
        });
        rowSerial = 1;
        result.excludedDrugs?.forEach((x) => {
          this.excludedDrugList.push({
            checked: false,
            topOrder: x.topOrder,
            processDrugAtpId: x.processDrugAtpId,
            processDrugType: x.processDrugType,
            fileUploadDrugId:x.processDrugAtpId, // rplace this old code x.fileUploadDrugId,
            ndc: x.ndc,
            customerDrugNdc: x.customerDrugNdc,
            barcode: x.barcode,
            name: x.name,
            customerDrugName: x.customerDrugName,
            mfgExpiration: x.mfgExpiration,
            strength: x.strength,
            canisterLocation: x.drawerType === 'Smart' ? 'SMART' : x.canisterLocation,
            pillForm: x.pillForm,
            volume: x.volume,
            pillVolume: x.pillVolume,
            lot: x.lot,
            qtyInCanister: x.qtyInCanister,
            color: x.color,
            shape: x.shape,
            marking: x.marking,
            description: x.description,
            packQuantity: x.packQuantity,
            costPerPill: x.costPerPill,
            apw: x.apw,
            controlSched: x.controlSched,
            comment: x.comment,
            doNotMix: x.doNotMix,
            active: x.active,
            min: x.min,
            max: x.max,
            invoiceNumber: x.invoiceNumber,
            smartId: x.smartId,
            genericSequenceNumber: x.genericSequenceNumber,
            assignedLot: x.assignedLot,
            assignedExpiration: x.assignedExpiration,
            distributor: x.distributor,
            drawerType: x.drawerType,
            drawer: x.drawer,
            usage: x.usage,
            noOfOrder: x.noOfOrder,
            otc: x.otc,
            schedule: x.schedule,
            thirtyDramCapacity: x.thirtyDramCapacity,
            manufacturer: x.manufacturer,
            statusForNotOral: x.statusForNotOral,
            oralSolidStatus: x.oralSolidStatus,
            nonCountReasonForNotAvailable: x.nonCountReasonForNotAvailable,
            tab: x.tab,
            automate: x.automate,
            excludedReason: x.excludedReason,
            dnuMaxForExclusion: x.dnuMaxForExclusion,
            gcValue: x.gcValue,
            hcGcValue: x.hcGcValue,
            cellLocOld: x.canisterLocation,
            atpCanisterNumber: x.atpCanisterNo,
            primaryDrugName: x.primaryDrugName,
            secondaryDrugName: x.secondaryDrugName,
            drugStatus: x.drugStatus,
            gcnSeqInExport: x.gcnSeqInExport,
            locationInExport: x.locationInExport,
            locationAnalysis: x.drawerType === 'Smart' ? 'SMART' : x.canisterLocation,
            customerComment: x.customerComment,
            customerInventoryNumber: x.customerInventoryNumber,
            otcOrVitamin: x.otcOrVitamin,
            canisterCapacity: x.canisterCapacity,
            mnemonic: x.mnemonic,
            genericName: x.genericName,
            genericNameIndicator: x.genericNameIndicator,
            fullColorName: x.fullColorName,
            fullShapeName: x.fullShapeName,
            imprint: x.imprint,
            dosageForm: x.dosageForm,
            weight: x.weight,
            scoring: x.scoring,
            routeOfAdministration: x.routeOfAdministration,
            isOralSolid: x.isOralSolid,
            niosh: x.niosh,
            dnu_max: x.dnu_max,
            str: x.str,
            uom: x.uom,
            form: x.form
          })
        })
        rowSerial = 1;
        result.notOralDrugs?.forEach((x) => {
          this.notOralDrugList.push({
            checked: false,
            topOrder: x.topOrder,
            processDrugAtpId: x.processDrugAtpId,
            processDrugType: x.processDrugType,
            fileUploadDrugId: x.processDrugAtpId, // rplace this old code x.fileUploadDrugId,
            ndc: x.ndc,
            customerDrugNdc: x.customerDrugNdc,
            barcode: x.barcode,
            name: x.name,
            customerDrugName: x.customerDrugName,
            mfgExpiration: x.mfgExpiration,
            strength: x.strength,
            canisterLocation: x.drawerType === 'Smart' ? 'SMART' : x.canisterLocation,
            pillForm: x.pillForm,
            volume: x.volume,
            pillVolume: x.pillVolume,
            lot: x.lot,
            qtyInCanister: x.qtyInCanister,
            color: x.color,
            shape: x.shape,
            marking: x.marking,
            description: x.description,
            packQuantity: x.packQuantity,
            costPerPill: x.costPerPill,
            apw: x.apw,
            controlSched: x.controlSched,
            comment: x.comment,
            doNotMix: x.doNotMix,
            active: x.active,
            min: x.min,
            max: x.max,
            invoiceNumber: x.invoiceNumber,
            smartId: x.smartId,
            genericSequenceNumber: x.genericSequenceNumber,
            assignedLot: x.assignedLot,
            assignedExpiration: x.assignedExpiration,
            distributor: x.distributor,
            drawerType: x.drawerType,
            drawer: x.drawer,
            usage: x.usage,
            noOfOrder: x.noOfOrder,
            otc: x.otc,
            schedule: x.schedule,
            thirtyDramCapacity: x.thirtyDramCapacity,
            manufacturer: x.manufacturer,
            statusForNotOral: x.statusForNotOral,
            oralSolidStatus: x.oralSolidStatus,
            nonCountReasonForNotAvailable: x.nonCountReasonForNotAvailable,
            tab: x.tab,
            automate: x.automate,
            excludedReason: x.excludedReason,
            dnuMaxForExclusion: x.dnuMaxForExclusion,
            gcValue: x.gcValue,
            hcGcValue: x.hcGcValue,
            cellLocOld: x.canisterLocation,
            atpCanisterNumber: x.atpCanisterNo,
            primaryDrugName: x.primaryDrugName,
            secondaryDrugName: x.secondaryDrugName,
            drugStatus: x.drugStatus,
            dosageForm: x.dosageForm,
            gcnSeqInExport: x.gcnSeqInExport,
            locationInExport: x.locationInExport,
            locationAnalysis: x.drawerType === 'Smart' ? 'SMART' : x.canisterLocation,
            customerComment: x.customerComment,
            customerInventoryNumber: x.customerInventoryNumber,
            otcOrVitamin: x.otcOrVitamin,
            canisterCapacity: x.canisterCapacity,
            isUnregulated: x.isUnregulated,
            mnemonic: x.mnemonic,
            genericName: x.genericName,
            genericNameIndicator: x.genericNameIndicator,
            fullColorName: x.fullColorName,
            fullShapeName: x.fullShapeName,
            imprint: x.imprint,
            weight: x.weight,
            scoring: x.scoring,
            routeOfAdministration: x.routeOfAdministration,
            isOralSolid: x.isOralSolid,
            niosh: x.niosh,
            dnu_max: x.dnu_max,
            str: x.str,
            uom: x.uom,
            form: x.form
          })
        })

        this.dataSource.data = this.analysisDrugList;

        this.dataSourceNotAbailable.data = this.notAvailableDrugList;
        this.dataSourceExcluded.data = this.excludedDrugList;
        this.dataSourceOral.data = this.notOralDrugList;
        this.dataSourcecellLocatorSheet.data = this.cellLocatorSheetList;
        this.ngxLoader.stop(ATPDRUGDATA_KEY);
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(ATPDRUGDATA_KEY);
        console.log(error)
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );

  }

  removeDrugCellLocation() {
    this.ngxLoader.start();
    this.drugCellLocationUpdateList = {
      customerId: this.customerId,
      addRemoveDrugs: this.drugCellLocationList,
    };
    this.imtoolAtpService.drugRemoveAtpCaps(this.drugCellLocationUpdateList).subscribe(
      (result) => {
        if (result.statusCode == 200) {
          this.toastService.openToast(
            result.message,
            constants.ToastPanelType.done,
            2
          );
          window.setTimeout(() => {
            window.location.reload();
          }, 2000);
          this.ngxLoader.stop();
        } else {
          this.toastService.openToast(
            result.message,
            constants.ToastPanelType.error,
            2
          );
          this.ngxLoader.stop();
        }
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  isCellLocationNotEmpty(): boolean {
    return this.drugCellLocationList.some(function (el) {
      return el.canisterLocation === "" || el.canisterLocation === null;
    });
  }

  addDrugCellLocation() {

    if (this.isCellLocationNotEmpty()) {
      this.toastService.openToast(
        "Please select a cell location to Add!",
        constants.ToastPanelType.error,
        2
      );
    }
    else {
      this.ngxLoader.start();
      this.drugCellLocationUpdateList = {
        customerId: this.customerId,
        addRemoveDrugs: this.drugCellLocationList,
      };
      this.imtoolAtpService.drugAddAtpCaps(this.drugCellLocationUpdateList).subscribe(
        (result) => {
          if (result.statusCode == 200) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );
            window.setTimeout(() => {
              window.location.reload();
            }, 2000);
            this.ngxLoader.stop();
          } else {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
            this.ngxLoader.stop();
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(
            error.error.message ?? error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
    }

  }


  openAlertWindowForDrugRemove() {
    var bodyMessage = this.isMultipleCellLocation == false ? "Are you sure, you want to remove this drug?" : "Multiple location detected for specific drug. Do you want to remove them all?";
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: "Remove Drug ?",
        bodyMessage: bodyMessage,
        bodyMessage2: this.drugCellLocationList
          .map((x, index) => {
            return `${index + 1}. ${x.drugName}`;
          })
          .join(" | "),
        cancelBtnText: "Cancel",
        confirmBtnText: "Remove",
        confirmButtonColor: "btn-light-red",
        cancelButtonColor: "btn-light-blue",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        console.log(result.data);
        this.removeDrugCellLocation();
      } else {
        console.log("not export", result);
      }
    });
  }

  openAlertWindowForDrugAdd() {
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: "Add Drug?",
        bodyMessage: "Are you sure you want to add this drug?",
        bodyMessage2: this.drugCellLocationList
          .map((x, index) => {
            return `${index + 1}. ${x.drugName}`;
          })
          .join(" | "),
        cancelBtnText: "Cancel",
        confirmBtnText: "Add",
        confirmButtonColor: "btn-light-red",
        cancelButtonColor: "btn-light-blue",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.addDrugCellLocation();
      } else {
        console.log("not export", result);
      }
    });
  }




  openImportWizardCDDB() {
    const dialogRef = this.dialog.open(ImportWizardCddbComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
      data: {
        customerId: this.customerId,
        deviceId: this.deviceId
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.getRecommendedDrugData(this.customerId, 0);
      } else {
        console.log("No change implement", result);
      }
    });
  }


  public doFilter = (value: string) => {
    if (this.tabSelected === 0)
      this.dataSource.filter = value.trim().toLocaleLowerCase();
    else if (this.tabSelected === 1)
      this.dataSourceNotAbailable.filter = value.trim().toLocaleLowerCase();
    else if (this.tabSelected === 2)
      this.dataSourceExcluded.filter = value.trim().toLocaleLowerCase();
    else this.dataSourceOral.filter = value.trim().toLocaleLowerCase();
  };


  openAlertWindow(data: number) {
    let title = "Confirm export"
    let message1 = "Are you sure you wish to export?"

    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: title,
        bodyMessage: message1,
        bodyMessage2: this.drugCellLocationList
          .map((x, index) => {
            return `${index + 1}. ${x.drugName}`;
          })
          .join(" | "),
        cancelBtnText: "Cancel",
        confirmBtnText: "Export",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        if (data == 3) {
          this.excelExportFromAtpTable()
        }
        else if(data==2){
          this.exportTheCanisterOrderFile()
        }
        else if (data == 1) {
          this.ExportCustomerDrug();
        }
      } else {
        console.log("not export", result);
      }
    });
  }

  redirectCustomerList() {
    this.router.navigate(["/im-tool"]);
  }
  openImportWizard() {
    const dialogSiteRef = this.dialog.open(ImportWizardComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
      data: {
        customer: {
          sl: 1,
          customerId: this.customerId,
          customerName: this.customerName,
          caseNumber: this.caseNumber,
          customerNumber: this.CustomerNumber,
          assetNumber: this.AssetNumber,
          deviceType: '',
          subDeviceTypeName: this.subDeviceTypeName,
          lastEdited: '',
          status: '',
          statusDescription: '',
          targetInstallDate: this.targetInstallDate,
        }, isparentnotassociated: 2
      },
    });
    dialogSiteRef.afterClosed().subscribe((result) => {
      // Refresh drug data to get the updated AssetNumber and CustomerNumber from backend
      this.getRecommendedDrugData(this.customerId, 0);
    });
  }

  openImportWizardDrugMovingComponent() {

    const dialogRef = this.dialog.open(ImportWizardDrugMovingComponent, {

      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        title: '',
        listOfData: [{ key: 1, value: 'Analysis', isSelected: this.tabSelected === 0 },
        { key: 2, value: 'New Drugs', isSelected: this.tabSelected === 1 },
        { key: 3, value: 'Excluded', isSelected: this.tabSelected === 2 },
        { key: 4, value: 'Not Oral Solid', isSelected: this.tabSelected === 3 },]
      }
    });
    dialogRef.afterClosed().subscribe((result) => {


      if (result.data.isClose === true) {
        this.onUpload(result.data.selectedTab, this.drugCellLocationList.map((x) => x.processDrugAtpId))
      }

    });
  }

  onUpload(selectedTab, drugs) {
    if (selectedTab === 0) {
      return
    }
    if (this.tabSelected === 2) {
      const blockedDrugs = this.excludedDrugList.filter(
        (d) => drugs.includes(d.processDrugAtpId)
          && d.excludedReason === 'Excluded during drug validation'
      );
      if (blockedDrugs.length > 0) {
        this.toastService.openToast(
          'Cannot move drugs that are Excluded During Drug Validation',
          constants.ToastPanelType.error,
          2
        );
        return;
      }
    }
    this.ngxLoader.start();
    this.moveDrug = {
      customerId: this.customerId,
      deviceId: this.deviceId,
      processDrugType: selectedTab,
      drugId: drugs,
    }
    this.imtoolService.moveDrugs(this.moveDrug).subscribe(
      (result) => {
        if (result.statusCode == 200) {
          this.toastService.openToast(
            result.message,
            constants.ToastPanelType.done,
            2
          );

          this.ngxLoader.stop();
          setTimeout(() => {
            location.reload();
          }, 2000)
        } else {
          this.toastService.openToast(
            result.message,
            constants.ToastPanelType.error,
            2
          );
          this.ngxLoader.stop();
        }
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  getCurrentDate(): string {
    const currentDate = new Date();
    const options: Intl.DateTimeFormatOptions = {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    };
    return currentDate.toLocaleDateString('en-US',options);
  }

}
